import { render, staticRenderFns } from "./BarChartApplication.vue?vue&type=template&id=08172ba3&scoped=true&"
import script from "./BarChartApplication.vue?vue&type=script&lang=js&"
export * from "./BarChartApplication.vue?vue&type=script&lang=js&"
import style0 from "./BarChartApplication.vue?vue&type=style&index=0&id=08172ba3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08172ba3",
  null
  
)

export default component.exports